import { render, staticRenderFns } from "./filepond.vue?vue&type=template&id=3cd9c30a"
import script from "./filepond.vue?vue&type=script&lang=js"
export * from "./filepond.vue?vue&type=script&lang=js"
import style0 from "./filepond.vue?vue&type=style&index=0&id=3cd9c30a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports